module.exports = __webpack_public_path__ + "static/media/news-feature.e6bb4045.png";